
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/branding/branding",
      function () {
        return require("private-next-pages/branding/branding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/branding/branding"])
      });
    }
  